import {
  getEndDateFromPreset,
  getStartDateFromPreset,
  presetToMonths,
} from "../../ui/components/filters/periodFilterPresets";

export const DASHBOARD_PERIOD_STORAGE_KEY = "dashboard.period";
const DEFAULT_DASHBOARD_PERIOD_PRESET = "last3months";

const startOfDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

const endOfDay = (date) => {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
};

const buildDashboardPeriodFromPreset = (presetId) => {
  const startDate = getStartDateFromPreset(presetId);
  const resolvedId = startDate ? presetId : DEFAULT_DASHBOARD_PERIOD_PRESET;
  const resolvedStart = startDate || getStartDateFromPreset(resolvedId);
  const endDate = getEndDateFromPreset(resolvedId);
  return {
    periodFilter: presetToMonths(resolvedId),
    periodStart: startOfDay(resolvedStart).toISOString(),
    periodStop: endOfDay(endDate).toISOString(),
    presetId: resolvedId,
  };
};

export const getDefaultDashboardPeriod = () =>
  buildDashboardPeriodFromPreset(DEFAULT_DASHBOARD_PERIOD_PRESET);

const hasValidDateRange = (periodStart, periodStop) => {
  const start = new Date(periodStart);
  const stop = new Date(periodStop);
  return !Number.isNaN(start.getTime()) && !Number.isNaN(stop.getTime());
};

export const writeStoredDashboardPeriod = (period) => {
  try {
    localStorage.setItem(
      DASHBOARD_PERIOD_STORAGE_KEY,
      JSON.stringify({
        periodFilter: period.periodFilter,
        periodStart: period.periodStart,
        periodStop: period.periodStop,
        periodDisplayLabel: period.periodDisplayLabel || "",
        presetId: period.presetId ?? null,
      }),
    );
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
};

export const resolveInitialDashboardPeriod = () => {
  try {
    const raw = localStorage.getItem(DASHBOARD_PERIOD_STORAGE_KEY);
    if (!raw) return getDefaultDashboardPeriod();

    const parsed = JSON.parse(raw);
    if (parsed?.presetId && getStartDateFromPreset(parsed.presetId)) {
      return {
        ...buildDashboardPeriodFromPreset(parsed.presetId),
        periodDisplayLabel: parsed.periodDisplayLabel || null,
      };
    }

    if (
      parsed?.periodStart &&
      parsed?.periodStop &&
      hasValidDateRange(parsed.periodStart, parsed.periodStop)
    ) {
      return {
        periodFilter:
          parsed.periodFilter === undefined ? null : parsed.periodFilter,
        periodStart: parsed.periodStart,
        periodStop: parsed.periodStop,
        periodDisplayLabel: parsed.periodDisplayLabel || null,
        presetId: null,
      };
    }
  } catch {
    return getDefaultDashboardPeriod();
  }

  return getDefaultDashboardPeriod();
};
